import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import GraduateTable from "../../Graduate_Table/Graduate_Table";
import Title from "../../Title/Title";

const Graduate_Students: React.FC = () => {
  return (
    <>
      <Row>
        <Col lg={3}>
          <Title title="الطلاب الخريجين" />
        </Col>
        <Col lg={8} className="flex justify-end">
          <button className=" bg-[#efc5e6] font-bold p-2 rounded-2xl mx-4">
            تصدير كملف اكسل
          </button>
          <button className=" bg-[#efc5e6] p-2 font-bold rounded-2xl">
            طباعة او PDF
          </button>
        </Col>
      </Row>

      <Row justify={"center"}>
        <Col lg={11} md={11} sm={11} className="border-2 rounded-lg !mt-3">
          <GraduateTable />
        </Col>
      </Row>
    </>
  );
};

export default Graduate_Students;
